module.exports = __webpack_public_path__ + "static/img/aAPLE.e94fe1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aAPLE.png
// module id = X2Pt
// module chunks = 1